export default __webpack_public_path__ + "static/media/iphone.88ee7a3b.jpg";